import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

export const ResizeHandleIcon = forwardRef<any, any>((props, ref) => (
  <Icon {...props} ref={ref}>
    <svg height="16" width="16" viewBox="0 0 16 16">
      <g clipPath="url(#clip0_20130_99992)">
        <line
          x1="3.10572"
          y1="13.0048"
          x2="13.0052"
          y2="3.10533"
          stroke="#B3B3B3"
          strokeWidth="1.5"
        />
        <line
          x1="8.05545"
          y1="13.7119"
          x2="13.7123"
          y2="8.055"
          stroke="#B3B3B3"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_20130_99992">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Icon>
));
